import { Skeleton } from '@mui/material'
import MuiCard from '@mui/material/Card'

import { commerceTheme as theme } from '@/themes/commerce/theme'

import type React from 'react'

export const ProductCardSkeleton: React.FC<{ ref?: React.Ref<HTMLDivElement> }> = ({ ref }) => (
  <MuiCard
    ref={ref}
    variant="outlined"
    sx={{
      position: 'relative',
      height: '100%',
      width: '100%',
      paddingInline: 2,
    }}
    elevation={0}
  >
    <Skeleton height={theme.customDimensions.productCardImageHeight} sx={{ mb: 1 }} />
    <Skeleton width={200} height={24} sx={{ mb: 0 }} />
    <Skeleton width={200} height={24} sx={{ mb: 1 }} />
    <Skeleton width={180} height={18} sx={{ mb: 0.5 }} />
    <Skeleton width={180} height={18} sx={{ mb: 0.5 }} />
    <Skeleton width={180} height={18} sx={{ mb: 0.5 }} />
    <Skeleton width={50} height={40} sx={{ mb: -2, float: 'right' }} />
    <Skeleton width="100%" height={80} sx={{ mb: -1 }} />
  </MuiCard>
)
